import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button } from '@material-ui/core';
import { cutString } from '../../../../common/utils';
import { globalData, ADD, EDIT, VIEW } from '../../../../common/common';
import { BorderColor } from '@material-ui/icons';
import EditPanel from '../InputsSingle/Panel/EditPanel';

const Root = styled(Box)({
    width: '100%',
    padding: '8px',
    '& .personTitle': {
        fontSize: '14px',
        marginBottom: '8px',
    },
    '& .dragDom': {
        minWidth: '110px',
        float: 'left',
        position: 'absolute',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        marginBottom: '8px',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .itemsWapper': {
        width: '100%',
    },
    '& .itemWapper': {
        width: '100%',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        marginBottom: '8px',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .itemWapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .itemWapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .edit': {
        width: '14px',
        height: '14px',
        color: '#009CEE',
        cursor: 'pointer',
    },
    '& .edit:hover': {
        color: '#43D79E',
    },
})

class EstatePList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mouseX: 0,
            mouseY: 0,
            isDown: false,
            dragData: null,
            openPanel: false,
            panelType: "",
            panelId: "",
            dataInfo: [],
            dataINFO: null
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleClosePanel = this.handleClosePanel.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
    }
    render() {
        const { pList } = this.props;
        const { dragData, mouseX, mouseY, openPanel, panelType, dataInfo, panelId, dataINFO } = this.state;
        const dragDiv = () => {
            if (dragData) {
                return <div id="dragDom" className={"dragDom c"} style={{ left: mouseX, top: mouseY }} title={dragData[".CHO.N."]}>{dragData[".CHO.N."]}</div>
            }
        }
        const editBtn = (index) => {
            if (pList.length > 1) {
                return <div id={index} onClick={this.handleClick}>
                    <BorderColor className="edit" />
                </div>
            }
        }
        return (
            <Root className="c">
                <div className="personTitle">Saved Person</div>
                <div className="itemsWapper">
                    {pList.map((obj, index) => (
                        <div className="h" key={index}>
                            <div id={index} className={"itemWapper c"} onMouseDown={this.onMouseDown} title={obj[".CHO.N."]}>{cutString(obj[".CHO.N."], 11)}</div>
                            {editBtn(index)}
                        </div>
                    ))}
                </div>
                {dragDiv()}
                <EditPanel
                    open={openPanel}
                    isAdd={false}
                    dataINFO={dataINFO}
                    data={dataInfo}
                    panelId={panelId}
                    panelType={panelType}
                    onClose={this.handleClosePanel}
                    updateInfoData={this.updateInfoData}
                ></EditPanel>
            </Root>
        )
    }
    componentDidMount() {
        const { data } = this.props;
        window.onmousemove = this.onMouseMove.bind(this);
        window.onmouseup = this.onMouseUp.bind(this);
        if (data) {
            this.setState({
                dataINFO: data.content["INFO"]
            })
        }
    }
    handleClick(e) {
        const { pList } = this.props;
        const index = e.currentTarget.id;
        if (index) {
            const dragData = pList[index];
            console.log("dragData",dragData)
            this.setState({
                dataInfo: dragData,
                panelId: dragData.id,
                panelType: dragData.type,
                openPanel: true
            })
        }
    }
    onMouseDown(e) {
        const index = e.target.id;
        console.log("aaa", index, e.target)
        if (index) {
            const { offsetL, offsetT, pList } = this.props;
            const dragData = pList[index];
            let mouseX = e.pageX - offsetL - 55;
            let mouseY = e.pageY - offsetT - 11;
            this.setState(() => ({
                dragData,
                mouseX,
                mouseY,
                isDown: true
            }))
            console.log("-----------按下----------")
            console.log(dragData)
            globalData.dragData = dragData;
            this.props.handleDown();
        }
    }
    onMouseUp(e) {
        const { isDown } = this.state;
        if (isDown === false) {
            return;
        }
        this.props.handleUp();
        this.setState(() => ({
            dragData: null,
            isDown: false
        }))
    }
    onMouseMove(e) {
        const { isDown } = this.state;
        const { offsetL, offsetT } = this.props;
        if (isDown === false) {
            return;
        }
        const mouseX = e.pageX - offsetL - 55;
        const mouseY = e.pageY - offsetT - 11;
        this.setState(() => ({
            mouseX,
            mouseY
        }))
        const obj = {
            left: e.pageX - offsetL,
            top: e.pageY - offsetT,
            width: 110,
            height: 22,
        }
        this.props.handleMove(obj);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleClosePanel() {
        this.setState({
            openPanel: false
        })
    }
    updateInfoData(panelData) {
        this.props.updateInfoData(panelData);
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default EstatePList;